
import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";
@Component
export default class UDescriptionList extends Vue {
  @Prop({ default: "100%" })
  public readonly maxDtWidth!: string;
  // Methods
  public render(h: CreateElement) {
    return h(
      "dl",
      { style: `--max-dt-width: ${this.maxDtWidth}` },
      this.$scopedSlots?.default && this.$scopedSlots.default({})
    );
  }
}
